import {
  GET_CURRENCIES_SUCCESS,
  GET_CURRENCIES_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  currencies: []
}

const Currencies = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CURRENCIES_SUCCESS:
      return {
        ...state,
        currencies: action ?.payload
      }

    case GET_CURRENCIES_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    default:
      return state
  }
}

export default Currencies
